/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ComponentType, FC } from 'react';

export type DynamicImportType = () => Promise<{
  default: ComponentType | FC<any>;
}>;

interface IBaseRouteConfig {
  path: string;
  children?: (IRouterConfig | ILazyRouterConfig)[];
}

/* 默认路由配置 */
export interface IRouterConfig extends IBaseRouteConfig {
  component: ComponentType;
  lazy: false;
}

/* 懒路由配置 */
export interface ILazyRouterConfig extends IBaseRouteConfig {
  component: DynamicImportType;
  lazy: true; // 是否懒加载。 默认为true
}

/* 重定向路由配置 */
export interface IRedirectRouterConfig {
  path: string;
  redirect: string;
}

export type IRouteType =
  | IRouterConfig
  | ILazyRouterConfig
  | IRedirectRouterConfig;

/**
 * 判断是否为重定向配置
 */
export function isRedirect(
  config: IRouteType,
): config is IRedirectRouterConfig {
  return !!(config as IRedirectRouterConfig).redirect;
}

/**
 * 判断是否为懒路由
 */
export function isLazyComponent(
  config: IRouteType,
): config is ILazyRouterConfig {
  return (config as ILazyRouterConfig).lazy;
}

const routerConfig: IRouteType[] = [
  {
    path: '/index',
    component: () => import('pages/index'),
    lazy: true,
  },
  {
    path: '/about',
    component: () => import('pages/about'),
    lazy: true,
  },
  {
    path: '/payment',
    component: () => import('pages/payment'),
    lazy: true,
  },
  {
    path: '/deposit/deposit-charge',
    component: () => import('pages/deposit-charge'),
    lazy: true,
  },
  {
    path: '/green/home',
    component: () => import('pages/green/home'),
    lazy: true,
  },
  {
    path: '/green/confirm-unlock',
    component: () => import('pages/green/confirm-unlock'),
    lazy: true,
  },
  {
    path: '/green/riding',
    component: () => import('pages/green/riding'),
    lazy: true,
  },
  {
    path: '/green/finish',
    component: () => import('pages/green/finish'),
    lazy: true,
  },
  {
    path: '/asian-games/riding',
    component: () => import('pages/asian-games/pages/riding'),
    lazy: true,
  },
  {
    path: '/asian-games/home',
    component: () => import('pages/asian-games/pages/home'),
    lazy: true,
  },
  {
    path: '/asian-games/unlock',
    component: () => import('pages/asian-games/pages/unlock'),
    lazy: true,
  },
  {
    path: '/asian-games/finish',
    component: () => import('pages/asian-games/pages/finish'),
    lazy: true,
  },
  {
    path: '/problem/assistant',
    component: () => import('pages/problem-assistant'),
    lazy: true,
  },
  {
    path: '/fault/report',
    component: () => import('pages/fault-report'),
    lazy: true,
  },
  {
    path: '/barrier/report',
    component: () => import('pages/barrier-report'),
    lazy: true,
  },
  {
    path: '/fault/report-v2',
    component: () => import('pages/fault-report-v2'),
    lazy: true,
  },
  {
    path: '/fault/report-records',
    component: () => import('pages/fault-report-records'),
    lazy: true,
  },
  {
    path: '/fault/report-record/detail',
    component: () => import('pages/fault-report-records/detail'),
    lazy: true,
  },
  {
    path: '/fault/report-record/new-detail',
    component: () => import('pages/fault-report-records/new-detail'),
    lazy: true,
  },
  {
    path: '/user/learning',
    component: () => import('pages/user-learning'),
    lazy: true,
  },
  {
    path: '/new-user/learning',
    component: () => import('pages/new-user-learning'),
    lazy: true,
  },
  {
    path: '/new-user/learning-v3',
    component: () => import('pages/new-user-edu-v3'),
    lazy: true,
  },
  {
    path: '/report/loading',
    component: () => import('pages/reportLoading'),
    lazy: true,
  },
  {
    path: '/report/loading-old',
    component: () => import('pages/reportLoadingOld'),
    lazy: true,
  },
  {
    path: '/helmet/check-result',
    component: () => import('pages/helmet-check-result'),
    lazy: true,
  },
  {
    path: '/oho/problem',
    component: () => import('pages/oho-problem'),
    lazy: true,
  },
  {
    path: '/oho/problem-list',
    component: () => import('pages/oho-problem-list'),
    lazy: true,
  },
  {
    path: '/oho/problem-detail',
    component: () => import('pages/oho-problem-detail'),
    lazy: true,
  },
  {
    path: '/bike/orders-detail',
    component: () => import('pages/bike-orders-detail'),
    lazy: true,
  },
  {
    path: '/oho/parkarea-close-notice',
    component: () => import('pages/parkarea-close-notice'),
    lazy: true,
  },
  {
    path: '/useBikeGuide',
    component: () => import('pages/use-bike-guide'),
    lazy: true,
  },
  {
    path: '/annualBill',
    component: () => import('pages/annual-bill'),
    lazy: true,
  },
  {
    path: '/parking-notice',
    component: () => import('pages/parking-notice'),
    lazy: true,
  },
  {
    path: '/penalty/learning',
    component: () => import('pages/penalty-learning'),
    lazy: true,
  },
  {
    path: '/penalty/learningNew',
    component: () => import('pages/penalty-learning-new'),
    lazy: true,
  },
  {
    path: '/complaint-return',
    component: () => import('pages/complaint-return'),
    lazy: true,
  },
  {
    path: '/complaint-return-guide-video',
    component: () => import('pages/complaint-return-guide-video'),
    lazy: true,
  },
  {
    path: '/apply-parking-dot',
    component: () => import('pages/apply-parking-dot'),
    lazy: true,
  },
  {
    path: '/guide-page',
    component: () => import('pages/guide-page/location'),
    lazy: true,
  },
  {
    path: '/blue-tooth-guide',
    component: () => import('@/pages/guide-page/bluetoothPage'),
    lazy: true,
  },
  {
    path: '/union-entry',
    component: () => import('pages/union-entry'),
    lazy: true,
  },
  // {
  //   path: '/',
  //   redirect: '/index',
  // },
];
export default routerConfig;
